import React from 'react';
import {Select, Typography} from '@acuity-brands/fusion';
import {normalizeSelectOptions} from 'common/components/form/utils';
import {FusionSelectPropTypes} from '../prop-types';

/**
 * @note Only for use inside the Form component. If you need to use
 * the Fusion Select component, use it directly.
 */
export const FusionSelectMultipleAdapter = ({
  data,
  disabled,
  errors,
  field,
  handleChange,
  name,
}) => {
  const options = normalizeSelectOptions(field.widget.choices);
  /**
   * Filter out selections that are not in the list of choices.
   * Unlikely to come up usually, but gets us around situations
   * where the backend passes us an array like [""] in response
   * to us passing them "" when no option has been selected.
   */
  const value = data
    ? data.filter((item) => options.some((option) => option.value === item))
    : [];
  return (
    <>
      <Select
        disabled={disabled}
        error={errors && errors.length > 0}
        errorTextPosition={'left'}
        fullWidth={true}
        label={field.widget.attrs.hideLabel ? '' : field.label}
        multiple={true}
        name={name}
        onChange={(event) => {
          handleChange(event.target.value);
        }}
        options={options}
        placeholder={field.widget.attrs.placeholder}
        required={field.required && !field.widget.attrs.hideLabel}
        tooltip={field.help_text}
        useCheckboxes={true}
        useChips={true}
        value={value ?? []}
      />
      {errors ? (
        <Typography error={!!errors.length}>{errors[0]}</Typography>
      ) : null}
    </>
  );
};

FusionSelectMultipleAdapter.propTypes = FusionSelectPropTypes;
